import GetTaskListRequestFilter from '../../../../../../projects/task/i-service/models/task/response/GetTaskListRequestFilter';
import SortingSettingsTask from '../../../../../../projects/task/i-service/models/task/request/SortingSettingsTask';
import PageRequest from '../../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение списка задач по дереву
 */
export default class GetTaskListByTreeShortRequest  {
	/**
	 * * Идентификатора пользователя
	 */
	CurrentUserId!: number;
	/**
	 * * Номер группы
	 */
	GroupId?: number;
	/**
	 * * Номер рабочей области
	 */
	NamespaceId?: string;
	/**
	 * * Список рабочих областей
	 */
	NamespaceIds!: Array<string>;
	/**
	 * * Список очередей
	 */
	QueueTaskIds!: Array<string>;
	/**
	 * * Номер проекта
	 */
	ProjectId?: number;
	/**
	 * * Дата начала трекинга
	 */
	DateStart?: Date;
	/**
	 * * Дата конца трекинга
	 */
	DateEnd?: Date;
	/**
	 * * Получение задач только где запускал таймер хотя бы один из исполнителей
	 */
	IsFilterTimerByPerformerIds: boolean = false;
	/**
	 * * Фильтр
	 */
	Filter!: GetTaskListRequestFilter;
	/**
	 * * Настрйка сортировки
	 */
	SortingSettings!: SortingSettingsTask;
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	constructor(obj?: Partial<GetTaskListByTreeShortRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
